import Axios from "axios";
import environment from "@/environment";
import { RequestInterceptor } from "./request.interceptor";
import { AuthService } from "./auth";
import { APP_STATUS_CODE } from "../helpers/enums";

export class HttpInterceptors {
	axios;

	constructor () {
		const interceptor = new RequestInterceptor();
		this.axios = Axios.create({ baseURL: `${environment.API}/v1` });
		this.axios.interceptors.request.use(interceptor.addAuthorizationHeader);
		this.axios.interceptors.response.use(
			response => response,
			async error => {
				const originalRequest = error.config;

				if (error.response && error.response.status === 401 && (!error.response.data.appStatusCode || error.response.data.appStatusCode !== APP_STATUS_CODE.ERR_RENEWAL_TOKEN)) {
					const authService = new AuthService();
					const newToken = await authService.renewToken();

					if (newToken) {
						console.log("Renewal successful. Retrying original request.");
						originalRequest.headers.Authorization = "Bearer " + newToken;
						return this.axios(originalRequest);
					} else {
						console.log("Renewal failed (no new token).");
					}
				}

				if (error.response) {
					switch (error.response.status) {
						case 401: // Sessao invalida
							import("../router").then(r => r.default.push("/login"));
							break;
						case 402: // Pagamento requerido
							import("../router").then(r => r.default.push({ path: "/renovar" }));
							break;
						case 403: // Usuário não possui o nível de acceso necessário
							import("../router").then(r => r.default.push("/forbidden"));
							break;
					}
				}

				return Promise.reject(error);
			}
		);
	}
}